module.exports = __webpack_public_path__ + "img/icon_quiz.c2be2555.svg";